<!-- @martyrs/src/modules/auth/views/components/AuthDialog.vue -->
<template>
  <Popup
    :isPopupOpen="authState.visible"
    @close-popup="closeAuth"
    @after-leave="$emit('after-leave')"
    class="bg-base radius-medium pd-medium"
  >
    <div class="t-center">
      <img loading="lazy" :src="'/favicon/favicon.svg'" class="i-extra radius-small mn-b-medium">
      <h3 class="mn-b-medium">{{ authState.title || t('auth.popup.title') }}</h3>
      <p class="mn-b-semi opacity-50">{{ authState.subtitle || t('auth.popup.subtitle') }}</p>

      <div class="flex-column flex gap-thin">
        <Button
          :submit="handleSignUp"
          class="bg-accent radius-small mn-b-small pd-thin"
        >
          {{ authState.buttonText || t('auth.popup.signUp') }}
        </Button>

        <span>
          {{ t('auth.popup.haveAccount') }}
          <a @click="handleSignIn" class="t-secondary cursor-pointer">{{ t('auth.popup.signIn') }}</a>
        </span>
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Popup from '@martyrs/src/design-system/components/Popup/Popup.vue';
import Button from '@martyrs/src/design-system/components/Button/Button.vue';

const { t } = useI18n();

defineEmits(['after-leave']);

const props = defineProps({
  authState: {
    type: Object,
    required: true
  },
  closeAuth: {
    type: Function,
    required: true
  }
});

const router = useRouter();
const route = useRoute();

const handleSignIn = async () => {
  const returnUrl = props.authState.returnUrl || route.fullPath;
  await router.push({
    name: 'Sign In',
    query: { returnUrl }
  });
  props.closeAuth('signin');
};

const handleSignUp = async () => {
  const returnUrl = props.authState.returnUrl || route.fullPath;
  await router.push({
    name: 'Sign Up',
    query: { returnUrl }
  });
  props.closeAuth('signup');
};
</script>